export default __webpack_public_path__ + "static/media/widget-drag.1bb80c02.svg";